// ============================================================
// LINKS INTERNOS QUE NO PIERDEN LA ATRIBUCION
// ------------------------------------------------------------
// La atribucion ya se guarda en sessionStorage (offers/attribution.ts),
// asi que tecnicamente no se pierde al navegar. Aun asi arrastramos el
// query string para que la URL sea legible, compartible, y para que la
// ruta /go/:slug pueda leer los parametros aunque alguien la abra en
// una pestana nueva.
// ============================================================

import { OFFERS, type Lang } from './config'

// Anade el query string actual a una ruta interna.
export const withQuery = (path: string, search: string) => {
  if (!search || search === '?') return path
  const sep = path.includes('?') ? '&' : '?'
  return `${path}${sep}${search.replace(/^\?/, '')}`
}

// Ruta de salida del afiliado. Un solo lugar que cambiar si manana el
// link de Kovo cambia o si entra otra oferta.
export const goPath = (slug: string, search = '') =>
  withQuery(`/go/${slug}`, search)

// Traduce una ruta de oferta al idioma activo:
//   /oferta/credito  <->  /offer/credit
// Cualquier otra ruta se devuelve tal cual.
export const localizePath = (path: string, lang: Lang) => {
  const m = path.match(/^\/(?:oferta|offer)\/([^/?#]+)/)
  if (!m) return path
  const offer = OFFERS.find((o) => o.slug === m[1] || o.enSlug === m[1])
  if (!offer) return path
  return lang === 'en' ? `/offer/${offer.enSlug}` : `/oferta/${offer.slug}`
}

// Ruta interna lista para usar: traducida al idioma y con el query.
export const internalHref = (path: string, lang: Lang, search = '') =>
  withQuery(localizePath(path, lang), search)
